import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { PopupNotificationProps } from "./PopupNotificationProps";
import { popupNotificationStyles } from "./PopupNotificationStyles";
import { ReactComponent as ErrorIcon } from "icons/AlertError.svg";
import { ReactComponent as SuccessIcon } from "icons/AlertSuccess.svg";
import { ReactComponent as WarningIcon } from "icons/AlertWarning.svg";
import { ReactComponent as InfoIcon } from "icons/AlertInfo.svg";
import { ReactComponent as CloseIcon } from "icons/AlertClose.svg";
import { ButtonBase, Typography } from "@material-ui/core";
import { useStore } from "store/StoreConfigs";
import { toast } from "react-toastify";

export function PopupNotification({
    type = "general",
    title,
    details,
    closeCallback,
}: PopupNotificationProps) {
    const classes = popupNotificationStyles();
    const { commonStore } = useStore();

    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        commonStore.incrementPopupsCount();
    }, []);

    const handleClose = () => {
        commonStore.decrementPopupsCount();

        if (commonStore.popupsCount === 0) {
            toast.dismiss("dismissAll");
        }

        closeCallback();
    };

    return (
        <div
            className={clsx(classes.container, {
                [classes.error]: type === "error",
                [classes.warning]: type === "warning",
                [classes.success]: type === "success",
            })}
        >
            <div className={classes.iconContainer}>
                {type === "general" && <InfoIcon />}
                {type === "success" && <SuccessIcon />}
                {type === "warning" && <WarningIcon />}
                {type === "error" && <ErrorIcon />}
            </div>
            <div className={classes.contentContainer}>
                <Typography variant="body2">{title}</Typography>
                {!expanded && !!details && (
                    <ButtonBase onClick={() => setExpanded(true)}>
                        <Typography
                            variant="body2"
                            className={classes.detailsButton}
                        >
                            Details
                        </Typography>
                    </ButtonBase>
                )}
                <br />
                {expanded && details}
            </div>
            <div className={classes.grow}></div>
            <ButtonBase
                className={classes.closeIconContainer}
                onClick={handleClose}
            >
                <CloseIcon />
            </ButtonBase>
        </div>
    );
}
